import React from 'react'
import ArchiveList from './ArchiveList.jsx'
import Loading from './Loading.jsx'
import SearchBar from './SearchBar.jsx'

var ArchiveModule = React.createClass({
  propTypes: {
    player: React.PropTypes.object.isRequired
  },
  getInitialState: function() {
    return {
      filterText: '',
      currentVideo: null,
      category: null,
      videos: []
    }
  },
  componentDidMount(){
    this.props.player.getVideos(() => {
      this.setState({
        videos: this.props.player.videos
      })
    })
  },
  handleUserSearch: function(filterText) {
    this.setState({filterText: filterText})
  },
  handleUserSelect: function(cat) {
    this.setState({category: cat})
  },
  render: function() {
    if(_.isEmpty(this.state.videos)) return <Loading/>
    var videos = this.state.videos
    return (
      <section className="recent-archives-section" style={{
        display: 'block'
      }}>
        <h2 className="header">
          <i className="fa fa-archive"></i> Archives ({videos.length})
        </h2>
        <SearchBar player={this.props.player} filterText={this.state.filterText} onUserSelectInput={this.handleUserSelect} onUserSearchInput={this.handleUserSearch}/>
        <ArchiveList player={this.props.player} videoLimit={this.props.videoLimit} external={this.props.external} category={this.state.category} filterText={this.state.filterText} videos={videos}></ArchiveList>
      </section>
    )
  }
})

module.exports = ArchiveModule



// WEBPACK FOOTER //
// ./src/components/ArchiveModule.jsx